import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
export default {
  name: 'SidebarItem',
  components: {
    Item: Item,
    AppLink: AppLink
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar'])), {}, {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  data: function data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild: function hasOneShowingChild() {
      var _this = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    // 跳转卡系统
    cardSystem: function cardSystem(title) {
      var src = '';
      if (title === '企业账号') {
        this.$router.push({
          path: '/cardSystem/customer/enterpriseManagement'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/customer/customer-account/index';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/customer/customer-account/index';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/customer/customer-account/index';
        }
        window.open(src, '_blank');
        return false;
      }
      // if (title === '客户列表') {
      //   this.$router.push({ path: '/cardSystem/customer/customerManagement' })
      //   if (process.env.VUE_APP_NAME === 'production') {
      //     src = 'https://voucher.youlianfuwu.com/customer/customer/index'
      //   } else if (process.env.VUE_APP_NAME === 'test') {
      //     src = 'https://vouchertest.youlianfuwu.com/customer/customer/index'
      //   } else {
      //     src = 'https://voucher.dev.youlianfuwu.com/customer/customer/index'
      //   }
      //   window.open(src, '_blank')
      //   return false
      // }
      if (title === '售卡记录') {
        this.$router.push({
          path: '/cardSystem/cardSales/cardSalesManagement'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/card/cardsale/index';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/card/cardsale/index';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/card/cardsale/index';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '回款计划(开票)') {
        this.$router.push({
          path: '/cardSystem/cardSales/invoicingManagement'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/card/paylog/list';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/card/paylog/list';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/card/paylog/list';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '发票管理') {
        this.$router.push({
          path: '/cardSystem/cardSales/invoiceManagement'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/card/userinvoice/index';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/card/userinvoice/index';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/card/userinvoice/index';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '返回卡系统') {
        this.$router.push({
          path: '/cardSystem/goBackCardSys/backCardIndex'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '电影资源') {
        this.$router.push({
          path: '/cardSystem/saleToos/movieResource'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/sales/sales-tools/movie';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/sales/sales-tools/movie';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/sales/sales-tools/movie';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '蛋糕资源') {
        this.$router.push({
          path: '/cardSystem/saleToos/cakeResource'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/sales/sales-tools/brand-list';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/sales/sales-tools/brand-list';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/sales/sales-tools/brand-list';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '蛋糕到家') {
        this.$router.push({
          path: '/cardSystem/saleToos/cakeHome'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/sales/sales-tools/cake-brand  ';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/sales/sales-tools/cake-brand';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/sales/sales-tools/cake-brand';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '演出资源') {
        this.$router.push({
          path: '/cardSystem/saleToos/showResource'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/sales/sales-tools/supplier-dudu';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/sales/sales-tools/supplier-dudu';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/sales/sales-tools/supplier-dudu';
        }
        window.open(src, '_blank');
        return false;
      }
      if (title === '电影报价工具') {
        this.$router.push({
          path: '/cardSystem/saleToos/moviePriceReport'
        });
        if (process.env.VUE_APP_NAME === 'production') {
          src = 'https://voucher.youlianfuwu.com/sales/sales-tools/movie-price-report';
        } else if (process.env.VUE_APP_NAME === 'test') {
          src = 'https://vouchertest.youlianfuwu.com/sales/sales-tools/movie-price-report';
        } else {
          src = 'https://voucher.dev.youlianfuwu.com/sales/sales-tools/movie-price-report';
        }
        window.open(src, '_blank');
        return false;
      }
    }
  }
};